//
import Service from '@/services/api/service'
import PurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'

//
 import fieldsCreateFromOrder   from './fieldsCreateFromOrder'

//
import fields    from './fields'
import headers   from './headers'
import includes  from './includes'

//
import fieldsDetail     from './fieldsDetail'
import fieldsRegistry   from './fieldsRegistry'
import headersDetail    from './headersDetail'

//
export default class extends Service {

    //
    static fields   = fields
    static headers          = headers
    static includes = includes

    //
    static fieldsCreateFromOrder= fieldsCreateFromOrder
    static fieldsDetail         = fieldsDetail
    static fieldsRegistry       = fieldsRegistry
    static headersDetail        = headersDetail
    
    //
    static model = PurchaseInvoiceModel
}
